module.exports = __webpack_public_path__ + "img/iio-instalaciones.a6318cd8.jpg";